export default __webpack_public_path__ + "static/media/play.c4b12d42.svg";